import { DirectMessageBaseClass } from '../DirectMessageBase';
import { Message } from '../DirectMessagesImport';
export class OTTRequestMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_OTT_REQUEST);
    }
}
